export default __webpack_public_path__ + "static/media/Credit-card.d9711b3c.png";